<template>
  <form autocomplete="off" id="form-add-document" class="position-relative" @submit.prevent="submit">
    <loader :loading="loadingForm" block />
    <div class="vuedl-layout__closeBtn" @click="close(true)">
      ×
    </div>
    <v-card>
      <v-card-title class="headline grey lighten-2 mb-4 justify-center" primary-title>
        {{ patient ? `Редактирование пациента №${patient.id}` : "Добавление пациента" }}
      </v-card-title>
      <v-card-text class="py-1">
        <v-text-field
          name="surname"
          prepend-icon="mdi-account"
          label="Фамилия*"
          required
          v-model="form.surname"
          :error-messages="validationErrors.surname"
          @input="makeLikeName($event, 'surname')"
        ></v-text-field>
        <v-text-field
          name="name"
          prepend-icon="mdi-account"
          label="Имя*"
          required
          :error-messages="validationErrors.name"
          v-model="form.name"
          @input="makeLikeName($event, 'name')"
        ></v-text-field>

        <v-text-field
          name="patronymic"
          prepend-icon="mdi-account"
          label="Отчество*"
          required
          v-model="form.patronymic"
          :error-messages="validationErrors.patronymic"
          @input="makeLikeName($event, 'patronymic')"
        ></v-text-field>
        <div class="d-flex">
          <v-text-field
            name="passport_series"
            label="Серия паспорта"
            prepend-icon="mdi-passport"
            required
            maxlength="4"
            v-model="form.passport_series"
            :error-messages="validationErrors.passport_series"
            @input="makeLikeName($event, 'passport_series')"
          ></v-text-field>
          <v-text-field
            name="passport_number"
            label="Номер паспорта"
            prepend-icon="mdi-passport"
            maxlength="6"
            required
            v-model="form.passport_number"
            :error-messages="validationErrors.passport_number"
            @input="makeLikeName($event, 'passport_number')"
          ></v-text-field>
        </div>

        <v-text-field
          name="passport_data"
          prepend-icon="mdi-passport"
          label="Дополнительная паспортная информация"
          required
          v-model="form.passport_data"
          :error-messages="validationErrors.passport_data"
          @input="makeLikeName($event, 'passport_data')"
        ></v-text-field>
        <date-picker
          label="Дата рождения*"
          :hide-details="true"
          v-model="form.birthdate"
          :max="new Date().toISOString()"
          :error-messages="validationErrors.birthdate"
        />

        <v-text-field
          name="email"
          prepend-icon="mdi-email"
          label="Email"
          type="email"
          v-model="form.email"
          :error-messages="validationErrors.email"
          autocomplete="new-password"
        ></v-text-field>
        <v-text-field
          name="phone"
          prepend-icon="mdi-phone"
          label="Телефон"
          v-model="form.phone"
          :error-messages="validationErrors.phone"
          @input="makeLikePhone($event, 'phone')"
        ></v-text-field>
        <v-radio-group v-model="form.sex" label="Пол" inline :error-messages="validationErrors.sex">
          <v-radio label="Женский" :value="1"></v-radio>
          <v-radio label="Мужской" :value="2"></v-radio>
        </v-radio-group>
        <v-text-field
          name="dms"
          prepend-icon="mdi-file-document-check-outline"
          label="Номер DMS"
          required
          v-model="form.dms"
        ></v-text-field>
        <v-text-field
          name="snils"
          prepend-icon="mdi-file-document-check-outline"
          label="СНИЛС"
          required
          v-model="form.snils"
        ></v-text-field>
        <v-select
          label="Обслуживающая организация"
          item-value="mis_organization_id"
          item-text="mis_organization_name"
          v-model="form.mis_organization_id"
          :loading="fetchOrg"
          :items="misOrgs"
          clearable
          :menu-props="{ closeOnContentClick: true }"
        ></v-select>
        <!-- <v-select
          clearable
          label="Место работы"
          item-value="organization_id"
          item-text="organization_fullname"
          v-model="form.organization_id"
          @change="
            form.position_id = null;
            form.structure_id = null;
          "
          :loading="fetchOrg"
          :items="orgList"
          :menu-props="{ closeOnContentClick: true }"
        ></v-select> -->
        <v-autocomplete
          clearable
          label="Место работы"
          item-value="organization_id"
          item-text="organization_fullname"
          v-model="form.organization_id"
          @change="
            form.position_id = null;
            form.structure_id = null;
          "
          :loading="fetchOrg"
          :items="orgList"
          :menu-props="{ closeOnContentClick: true }"
        ></v-autocomplete>
        <!-- <v-select
          clearable
          label="Отдел"
          item-value="id"
          item-text="fullname"
          v-model="form.structure_id"
          :loading="fetchOrg"
          :items="structuresList"
          :menu-props="{ closeOnContentClick: true }"
          :error-messages="validationErrors.structure_id"
        ></v-select> -->
        <v-combobox
          clearable
          :items="structuresList"
          :loading="fetchOrg"
          label="Отдел"
          :error-messages="validationErrors.structure_id"
          @update:search-input="form.structure_id = $event"
          v-model="form.structure_id"
          item-value="id"
          item-text="fullname"
        >
        </v-combobox>
        <v-combobox
          clearable
          :items="positionsList"
          label="Должность"
          :error-messages="validationErrors.position_id"
          v-model="form.position_id"
          item-value="id"
          item-text="name"
          @update:search-input="form.position_id = $event"
        >
        </v-combobox>
        <v-autocomplete
          clearable
          :items="insuranceList"
          label="Страховая"
          :error-messages="validationErrors.insurance_company_id"
          v-model="form.insurance_company_id"
          item-value="id"
          item-text="name"
          :menu-props="{ closeOnContentClick: true }"
        >
        </v-autocomplete>
        <v-checkbox v-model="form.pd_consent" label="ПД - согласие предоставлено" class="mt-0"></v-checkbox>
        <!-- insurance_program_id => GET /v1/insurance/companies/{companyId}/programs -->
        <!-- <v-text-field
          type="password"
          required
          prepend-icon="mdi-form-textbox-password"
          label="Password"
          v-model="form.password"
          autocomplete="new-password"
        ></v-text-field> -->
        <div class="d-flex w-100">
          <img v-if="patient && patient.avatar" :src="patient.avatar" width="100" class="flex-shrink-0 mt-1 pt-3" alt="" />
          <base-input-file class="flex-grow-1" label="Фотография профиля" @change="form.avatar = $event" />
        </div>
      </v-card-text>

      <v-divider class="mt-4"></v-divider>
      <v-card-actions>
        <v-btn id="form-add-cancel" color="primary" text @click="close(true)">Отменить</v-btn>
        <v-spacer></v-spacer>
        <v-btn id="form-add-allergy-submit-and-open" color="primary" class="mr-10" text @click="submit(true)">
          Сохранить и открыть
        </v-btn>
        <v-btn id="form-add-allergy-submit" color="primary" text @click="submit">
          Сохранить
        </v-btn>
      </v-card-actions>
    </v-card>
  </form>
</template>
<script>
import BaseInputFile from "@/components/forms/BaseInputFile.vue";
import { formModal } from "@/mixins/modal/form-modal.js";
import { API_ERROR_MESSAGE } from "@/config.js";
import { required, email, maxLength, numeric } from "vuelidate/lib/validators";
import DatePicker from "@/components/forms/DatePicker";
import { PatientsRepository } from "@/modules/patients/patients.repository";
import Loader from "@/components/Loader";
import { messageHelper } from "@/services/validation-helper";
import dayjs from "dayjs";
import { v4 } from "uuid";
import Vue from "vue";
export default Vue.extend({
  name: "AddPatient",
  components: { BaseInputFile, DatePicker, Loader },
  props: {
    patient: {
      type: [Object, null],
      default: null,
    },
  },
  data() {
    return {
      loadingForm: false,

      commonErrors: "",
      birthdatePicker: false,
      form: {
        surname: "",
        name: "",
        patronymic: "",
        birthdate: "",
        phone: "",
        email: null,
        sex: null,
        password: "",
        avatar: null,
        dms: "",
        snils: "",
        organization_id: null,
        structure_id: null,
        position_id: null,
        passport_series: "",
        passport_number: "",
        passport_data: "",
        mis_organization_id: "",
        pd_consent: false,
      },
      orgList: [],
      misOrgs: [],
      positionsList: [],
      insuranceList: [],
      fetchOrg: false,
    };
  },
  mixins: [formModal],
  validations: {
    form: {
      surname: { required },
      name: { required },
      patronymic: { required },
      birthdate: { required },
      sex: { required },
      passport_series: { numeric },
      passport_number: { numeric },
      //   structure_id: {
      //     required: requiredIf(function(form) {
      //       return !!form.organization_id;
      //     }),
      //   },
      //   position_id: {
      //     required: requiredIf(function(form) {
      //       return !!form.organization_id;
      //     }),
      //   },
      email: {
        email,
      },
      phone: {
        maxLength: maxLength(12),
      },
    },
  },
  computed: {
    repo() {
      return new PatientsRepository();
    },
    validationErrors() {
      return {
        surname: messageHelper(this.$v.form.surname),
        name: messageHelper(this.$v.form.name),
        patronymic: messageHelper(this.$v.form.patronymic),
        birthdate: messageHelper(this.$v.form.birthdate),
        email: messageHelper(this.$v.form.email),
        phone: messageHelper(this.$v.form.phone),
        sex: messageHelper(this.$v.form.sex),
        passport_number: messageHelper(this.$v.form.passport_number),
        passport_series: messageHelper(this.$v.form.passport_series),
        // structure_id: messageHelper(this.$v.form.structure_id),
        // position_id: messageHelper(this.$v.form.position_id),
      };
    },
    currentOrg() {
      if (this.orgList && this.orgList.length && this.form.organization_id) {
        return this.orgList.find(el => el.organization_id === this.form.organization_id);
      }
      return null;
    },
    structuresList() {
      if (this.currentOrg) {
        return this.currentOrg.structures;
      }
      return [];
    },
  },
  methods: {
    makeLikePhone(src, key) {
      let newsrc = src.replace(/\D/g, "");
      console.log(`newsrc =>`, newsrc);
      if (["7", "8"].includes(newsrc[0])) {
        newsrc = newsrc.slice(1);
        newsrc = "+7" + newsrc;
      }
      this.form[key] = newsrc + " ";
      this.$nextTick(() => {
        this.form[key] = newsrc;
      });
    },

    makeLikeName(src, key) {
      src = src.charAt(0).toUpperCase() + src.slice(1);
      this.form[key] = src;
    },

    loading(val) {
      this.loadingForm = val;
      this.$emit("loading", val);
    },
    async submit(openAfterCreate = false) {
      this.$v.form.$touch();
      if (this.$v.form.$pending || this.$v.form.$error) return;
      this.loading(true);
      try {
        const preparedForm = Object.assign({}, this.form);
        if (preparedForm.position_id) {
          if (typeof preparedForm.position_id !== "string") {
            preparedForm.position_id = preparedForm.position_id.id;
          }
        }
        if (preparedForm.structure_id) {
          if (typeof preparedForm.structure_id !== "string") {
            preparedForm.structure_id = preparedForm.structure_id.id;
          }
        }
        if (preparedForm.avatar) {
          preparedForm.avatar;
        }
        const res = this.patient
          ? await this.repo.updatePatient(preparedForm, this.patient.id)
          : await this.repo.createPatient(preparedForm);
        console.log(`res =>`, res);
        if (res.ok) {
          if (res.exist) {
            this.$dialog.notify.error("Такой пользователь существует");
          } else {
            if (this.form.mis_organization_id) {
              if (res.data) {
                await this.repo.setMisOrganization(res.data, this.form.mis_organization_id);
              } else if (this.patient) {
                await this.repo.setMisOrganization(
                  this.patient.id,
                  this.form.mis_organization_id,
                  this.patient.mis_organization.id,
                );
              }
            }
            if (openAfterCreate && res.data) {
              // this.$router.push()
              const newPath = `?customer_id=${res.data}&doctor_id=${this.$store.state.auth.id}#/ikp`;
              const domain = window.location.origin;
              window.open(domain + newPath, "_blank").focus();
            }
            this.$emit("submit", true);
            this.close();
          }
        } else {
          throw res.data;
        }
      } catch (e) {
        console.log(`e =>`, e);
        if (e.response && e.response.data) {
          this.commonErrors = `
                <p class="font-bold">${e.response.data.message || ""}</p>
                <p class='text-sm'>${e.response.data.specification_error || ""}</p>
            `;
        }
        this.$dialog.notify.error(e?.response?.message || API_ERROR_MESSAGE);
      }

      this.loading(false);
    },
  },
  async created() {
    this.loading(true);
    this.fetchOrg = true;
    const [orgs, positions, misOrgs, insurance] = await Promise.all([
      this.$http.get(`/v1/organizations`, { params: { lang: "ru" } }),
      this.$http.get(`/v1/organizations/positions`, { params: { lang: "ru" } }),
      this.$http.get(`/v1/clinics`, { params: { lang: "ru" } }),
      this.$http.get(`/v1/insurance/companies`, { params: { lang: "ru" } }),
    ]);
    if (orgs.data.success) {
      this.orgList.push(...orgs.data.data);
    }
    if (positions.data) {
      this.positionsList.push(...positions.data.data);
    }
    if (insurance.data) {
      this.insuranceList.push(...insurance.data.data);
    }
    if (misOrgs.data) {
      this.misOrgs.push(...misOrgs.data.data);
    }
    this.fetchOrg = false;

    if (this.patient) {
      this.form.organization_id = this.patient.organization.id;
      const patientOrganization =
        this.patient.organization && this.patient.organization.full_name
          ? this.orgList.find(org => org.organization_fullname === this.patient.organization.full_name)
          : null;

      const patientPosition = this.positionsList.find(pos => pos.name === this.patient.position);
      const patientStructure = patientOrganization
        ? patientOrganization.structures.find(pos => pos.fullname === this.patient.structure)
        : null;

      const patientInsuranceCompany = this.insuranceList.find(com => com.id === this.patient.insurance_company?.id);
      this.form.surname = this.patient.last_name;
      this.form.name = this.patient.first_name;
      this.form.patronymic = this.patient.middle_name;

      const validBD = dayjs(this.patient.birthday).isValid() ? dayjs(this.patient.birthday) : null;
      this.form.birthdate = validBD;

      this.form.phone = this.patient.phone;
      this.form.email = this.patient.email;
      this.form.sex = ["Мужской", 2].includes(this.patient.sex) ? 2 : 1;
      //   this.form.password = this.patient.password;
      //   this.form.avatar = this.patient.avatar;
      this.form.dms = this.patient.dms;
      this.form.snils = this.patient.snils;
      this.form.passport_data = this.patient.passport_data;
      this.form.passport_series = this.patient.passport_series;
      this.form.passport_number = this.patient.passport_number;

      this.form.mis_organization_id = this.patient.mis_organization.id;

      this.form.organization_id = patientOrganization ? patientOrganization.organization_id : null;
      this.form.structure_id = patientStructure ? patientStructure : null;
      this.form.position_id = patientPosition ? patientPosition : null;
      this.form.insurance_company_id = patientInsuranceCompany ? patientInsuranceCompany.id : null;
      this.form.pd_consent = this.patient.pd_consent || false;
    }
    this.loading(false);
  },
});
</script>
